import _ from "lodash";
import { wealthProApi } from "../../redux/api";
import { useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";
import {LiveGraphSubscriptionType} from "../../types/GraphSubscriptionType";

// NOTE: This set of endpoints deals with live directly on 365 requests
// including the fetch and link commands

type LiveSubscriptionCacheData = CursorPagedResults<LiveGraphSubscriptionType> & {
    cacheKey: number
};

const graphLiveSubscriptionApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ['graphSubscriptions']
}).injectEndpoints({
    endpoints: (builder => ({
        fetchLiveSubscriptions: builder.query({
            query: (args: { cacheKey: number, nextLink: string | null }) => args.nextLink !== null
                ? `api/graph/graph/subscriptions?nextLink=${args.nextLink}`
                : `api/graph/graph/subscriptions`,
            transformResponse: useCacheKeyTransformResponseHandler,
            serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            merge: (currentCache: LiveSubscriptionCacheData, newCache: LiveSubscriptionCacheData) => {
                if (_.isEqual(currentCache.cacheKey, newCache.cacheKey)) {
                    currentCache.nextLink = newCache.nextLink;
                    currentCache.results.push(...newCache.results);
                }
                else {
                    currentCache.cacheKey = newCache.cacheKey;
                    currentCache.nextLink = newCache.nextLink;
                    currentCache.results = [...newCache.results];
                }
            },
        }),
        linkLiveSubscription: builder.mutation({
            query: (data: { userId?: string | null, subscriptionId: string }) => ({
                url: `api/graph/graph/subscriptions`,
                method: 'POST',
                body: data
            })
        })
    }))
});

export const {
    useFetchLiveSubscriptionsQuery,
    useLazyFetchLiveSubscriptionsQuery,
    useLinkLiveSubscriptionMutation
} = graphLiveSubscriptionApiEndpoints;